import { HOLESKY } from '../types';
export default {
  type: HOLESKY,
  service: 'myetherwallet.com-ws',
  url: 'wss://nodes.mewapi.io/ws/holesky',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
